import axios from 'axios'

const isHandlerEnabled = (config = {}) => {
  return !(config.hasOwnProperty('handlerEnabled') && !config.handlerEnabled)
}

const instance = axios.create({
  baseURL: process.env.SERVER_HOST,
  headers: { 'content-type': 'application/json' },
  timeout: 10000
})

const requestHandler = request => {
  if (isHandlerEnabled(request)) {
    console.log('Request Interceptor', request)
  }
  return request
}

const errorHandler = error => {
  if (isHandlerEnabled(error.config)) {
    console.log('Error Interceptor', error)
  }
  // eslint-disable-next-line
  return Promise.reject({ ...error })
}

const successHandler = response => {
  if (isHandlerEnabled(response.config)) {
    console.log('Response Interceptor', response)
  }
  return response
}

instance.interceptors.request.use(request => requestHandler(request))

instance.interceptors.response.use(
  response => successHandler(response),
  error => errorHandler(error)
)

export default instance



// WEBPACK FOOTER //
// ./src/http/httpResource.js